import React from 'react';

interface ChipProps {
  active?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  as?: 'span' | 'button';
  title?: string;
}

export default function Chip({
  active = false,
  onClick,
  children,
  className = '',
  as,
  title,
}: ChipProps) {
  const clickable = !!onClick;
  const Tag: 'span' | 'button' = as ?? (clickable ? 'button' : 'span');

  const base =
    'inline-flex items-center gap-1.5 px-[10px] py-[4px] rounded-full font-mono text-[10px] font-medium uppercase tracking-[0.4px] border transition-colors';
  const style = active
    ? 'bg-[color-mix(in_srgb,var(--accent)_14%,transparent)] text-accent border-[color-mix(in_srgb,var(--accent)_30%,transparent)]'
    : 'bg-surface text-text-muted border-border';
  const cursor = clickable ? 'cursor-pointer hover:text-text hover:border-border-hi' : 'cursor-default';

  return (
    <Tag
      {...(Tag === 'button'
        ? { type: 'button' as const, onClick }
        : {})}
      title={title}
      className={`${base} ${style} ${cursor} ${className}`}
    >
      {children}
    </Tag>
  );
}
